import React from 'react';
import { useTranslation } from 'react-i18next';
import DivContainer from '../components/DivContainer';
import MenuItemIcon from '../components/MenuItemIcon';

export const OrderFuelOrderTypeContainer = (props) => {
    const {t} = useTranslation();
    const {handleAnwimSelect, handleOwnDeliverySelect, handleAdblueLpgSelect, element} = props;
    return (
        <React.Fragment>
            <DivContainer colClass='row order-type-icon'>
                <DivContainer colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                    <div className={!element?.anwimDelivery ? 'order-fuel-order-type' : 'order-fuel-order-type selected'} onClick={handleAnwimSelect}>
                        <MenuItemIcon
                            alt={t('order-fuel.anwim')}
                            className='icon-svg left'
                            iconSvg={'ico_anwim_delivery_order'}
                        />
                        <span>{t('order-fuel.anwim')}</span>
                    </div>
                </DivContainer>
                <DivContainer colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                    <div className={!element?.ownDelivery ? 'order-fuel-order-type' : 'order-fuel-order-type selected'} onClick={handleOwnDeliverySelect}>
                        <MenuItemIcon
                            alt={t('order-fuel.own')}
                            className='icon-svg left'
                            iconSvg={'ico_own_delivery_order'}
                        />
                        <span>{t('order-fuel.own')}</span>
                    </div>
                </DivContainer>

                <DivContainer colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                    <div className={!element?.adBlueLpg ? 'order-fuel-order-type' : 'order-fuel-order-type selected'} onClick={handleAdblueLpgSelect}>
                        <MenuItemIcon
                            alt={t('order-fuel.adBlueAndLpg')}
                            className='icon-svg left'
                            iconSvg={'ico_adblue_lpg_order'}
                        />
                        <span>{t('order-fuel.adBlueAndLpg')}</span>
                    </div>
                </DivContainer>
            </DivContainer>
        </React.Fragment>
    );
};
